"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importStar(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const zod_1 = require("zod");
const access_1 = require("../../../../../common/constants/access");
const errorUtil_1 = require("../../../../../common/lib/errorUtil");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const companyQuery_1 = require("../../../../queries/companyQuery");
const currenciesQuery_1 = require("../../../../queries/currenciesQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const Root_1 = require("../../../../router/Root");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const cards_1 = __importDefault(require("../../../templates/teamSettings/cards"));
const cards_2 = require("../../companySettings/cards");
const useTeamsState_1 = require("../overview/hooks/useTeamsState");
const logger = (0, pino_1.default)();
const includeSelectTeams = false;
const includeRemoveCard = true;
const TeamSettingsCardsPage = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const { data: teams } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamsQuery)(),
        initialData: initialData.teams,
    });
    const { data: team } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamQuery)({ teamId: teamId?.[0] || '' }),
    });
    const { data: hasAccess } = (0, react_query_1.useQuery)({
        ...(0, userQuery_1.getVerifyUserAccessQuery)(access_1.composites.WRITE_CARD_SOURCES),
        initialData: initialData.hasAccess,
    });
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)({
        ...(0, companyQuery_1.companyPropertiesQuery)(userData.companyAccountId, { cardprovider: 'tsgo-cardprovider' }),
        initialData: initialData.companyProperties,
    });
    const { data: currencies } = (0, react_query_1.useQuery)((0, currenciesQuery_1.getCurrenciesQuery)(teamId?.[0] || ''));
    const { data: companyCards } = (0, paymentQuery_1.useGetCompanyCardSourcesQuery)({
        ...paymentQuery_1.paymentParams,
        isEnabled: true,
    });
    const addCardSourceToTeam = (0, paymentQuery_1.useAddCardSourceToTeamQuery)();
    const removeCardSourceFromTeam = (0, paymentQuery_1.useRemoveCardSourceFromTeamQuery)();
    const setCardName = (0, paymentQuery_1.useSetCardNameQuery)({ shouldSetOnCompanyCard: false });
    const setCurrentTeamById = (0, teamQuery_1.useSetCurrentTeamByIdQuery)();
    const enrollWithAmexV2 = (0, paymentQuery_1.useEnrollCardV2Query)();
    const { setPageLoading } = (0, zustandStore_1.useZustand)();
    const state = (0, useTeamsState_1.useTeamsState)();
    (0, react_1.useEffect)(() => {
        if (team) {
            state.setTeam(team);
        }
    }, [state.setTeam, team]);
    const resetAsides = (0, react_1.useCallback)(() => {
        state.setIsCardSourceDetailOpen({ isOpen: false, cardSourceId: '' });
        state.setIsAddSourceCardOpen(false);
        state.setIsSelectCardSourceOpen(false);
    }, [state]);
    const [cardAsides, setCardAsides] = (0, react_1.useState)({
        cantRemoveCard: {
            isOpen: false,
            message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? strings_1.cardDetailStrings.HSBC_CANT_REMOVE_CARD
                : strings_1.cardDetailStrings.CANT_REMOVE_CARD,
        },
        removeCard: {
            isOpen: false,
            message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? strings_1.cardDetailStrings.HSBC_REMOVE_CARD
                : strings_1.cardDetailStrings.REMOVE_CARD,
        },
        selectTeams: {
            isOpen: false,
            model: {
                id: [],
            },
            options: [],
            title: strings_1.cardDetailStrings.SELECT_TEAMS,
        },
    });
    (0, react_1.useEffect)(() => {
        if (userData) {
            state.setUser(userData);
            state.setCompanyName(userData.companyName);
            state.setCompanyId(userData.companyAccountId);
        }
    }, [state.setCompanyId, state.setCompanyName, state.setUser, userData]);
    (0, react_1.useEffect)(() => {
        if (hasAccess) {
            state.setCanForwardApprovals(hasAccess);
        }
    }, [hasAccess, state.setCanForwardApprovals]);
    (0, react_1.useEffect)(() => {
        if (teamId != null && teamId.length > 0 && teamId?.[0] !== '') {
            state.setTeamId(teamId?.[0] || '');
        }
    }, [state.setTeamId, teamId]);
    (0, react_1.useEffect)(() => {
        state.setHeaderName(team?.name || '');
    }, [state.setHeaderName, team?.name]);
    (0, react_1.useEffect)(() => {
        const selectedTeams = state.cardSourceTeams?.filter(team => team.state === appConstants_1.userStatus.ACTIVE);
        setCardAsides(prevState => ({
            ...prevState,
            selectTeams: {
                ...prevState.selectTeams,
                model: {
                    ...prevState.selectTeams.model,
                    id: selectedTeams?.map(team => team.id),
                },
                options: selectedTeams,
            },
        }));
        getSelectTeamOptions();
    }, [state.cardSourceTeams]);
    const initialize = (0, react_1.useCallback)(() => {
        if (Array.isArray(teamId) && teamId.length > 0) {
            setCurrentTeamById.mutate({ selectedTeamID: teamId?.[0] || '' });
        }
    }, [setCurrentTeamById, teamId]);
    const validate = (0, react_1.useCallback)(({ cardSource, cardProvider, companyCards, }) => {
        let errors = {};
        const cardSourceValidation = (0, cards_2.CardSourceSchema)(cardProvider).safeParse(cardSource);
        if (cardSourceValidation.success) {
            const validCardSource = cardSourceValidation.data;
            if (validCardSource.id &&
                companyCards?.find(source => source.id === validCardSource.id && source.name === validCardSource.name)) {
                return true;
            }
            else if (validCardSource &&
                !lodash_1.default.isEmpty(validCardSource) &&
                validCardSource.name &&
                companyCards?.find(source => source.name === validCardSource.name)) {
                errors = {
                    ...errors,
                    name: strings_1.cardDetailStrings.DUPLICATE_CARD_ERROR({ cardName: validCardSource.name }),
                };
            }
        }
        else {
            const treeifiedError = zod_1.z.treeifyError(cardSourceValidation.error);
            if (treeifiedError.properties) {
                for (const [field, issue] of Object.entries(treeifiedError.properties)) {
                    logger.warn(`${field} issue: ${issue}`);
                    errors[field] = issue.errors[0];
                }
            }
        }
        state.cardSourceSetErrors(errors);
        return Object.keys(errors).length === 0;
    }, []);
    const submitCardSourceData = (0, react_1.useCallback)((formData, cardProvider) => {
        setPageLoading(true);
        if (!validate({ cardSource: formData, cardProvider, companyCards })) {
            setPageLoading(false);
            return;
        }
        enrollWithAmexV2.mutate({
            enrollData: { ...formData, billingCurrency: currencies?.[0] || 'N/A' },
            teamId: teamId?.[0] || '',
            cardProvider: companyPropertiesData?.cardprovider || '',
        }, {
            onSuccess: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: strings_1.messageStrings.CREDIT_CARD_SUCCESS_MESSAGE,
                    },
                ]);
            },
            onError: error => {
                if ((0, errorUtil_1.isCardsProviderError)(error)) {
                    state.setNotification([
                        {
                            type: strings_1.notificationStrings.WARNING,
                            message: strings_1.messageStrings.CARD_PROVIDER_WARNING_MESSAGE,
                        },
                    ]);
                }
                else {
                    state.setNotification([
                        {
                            type: strings_1.notificationStrings.WARNING,
                            message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? strings_1.errorStrings.DEFAULT
                                : strings_1.messageStrings.CARD_WARNING_ERROR,
                        },
                    ]);
                }
            },
            onSettled: () => {
                state.setIsAddSourceCardOpen(false);
                resetAsides();
                initialize();
                setPageLoading(false);
            },
        });
    }, [companyPropertiesData?.cardprovider, currencies, teamId, companyCards]);
    const linkCardSourceToTeam = (cardSourceId) => {
        setPageLoading(true);
        addCardSourceToTeam.mutate({ teamId: teamId?.[0] || '', cardSourceId }, {
            onSuccess: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? strings_1.cardDetailStrings.HSBC_CREDIT_CARD_LINK_SUCCESS_MESSAGE
                            : strings_1.cardDetailStrings.CREDIT_CARD_LINK_SUCCESS_MESSAGE,
                    },
                ]);
            },
            onError: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.WARNING,
                        message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? strings_1.errorStrings.DEFAULT
                            : strings_1.cardDetailStrings.CREDIT_CARD_LINK_ERROR_MESSAGE,
                    },
                ]);
            },
            onSettled: () => {
                resetAsides();
                initialize();
                void Root_1.queryClient.invalidateQueries({
                    queryKey: [
                        paymentQuery_1.paymentKeys.getTeamCardSources({
                            includeTeamsCount: true,
                            teamId: teamId?.[0] || '',
                            isEnabled: true,
                        }),
                    ],
                });
                state.setIsAddSourceCardOpen(false);
                setPageLoading(false);
            },
        });
    };
    const getSelectTeamOptions = () => {
        if (!includeSelectTeams) {
            return;
        }
        const activeTeams = teams.filter(team => team.state === appConstants_1.userStatus.ACTIVE);
        return activeTeams.filter(team => {
            const selectedTeamIds = state.cardSourceTeams?.filter(team => team.state === appConstants_1.userStatus.ACTIVE).map(team => team.id) || [];
            return !selectedTeamIds.includes(team.id);
        });
    };
    const toggleCardDetailsAside = (value, id = '') => {
        state.setIsCardSourceDetailOpen({ isOpen: value, cardSourceId: id });
    };
    const toggleCard = (type, value) => {
        if (type === '' || type === null || type === undefined) {
            type =
                state.teamCards && state.teamCards.length > 1
                    ? appConstants_1.cardDetailsAsideProperties.REMOVE_CARD
                    : appConstants_1.cardDetailsAsideProperties.CANT_REMOVE_CARD;
        }
        setCardAsides(prevState => ({
            ...prevState,
            [type]: {
                ...prevState[type],
                isOpen: value,
            },
        }));
    };
    const saveConfirmAside = () => {
        setPageLoading(true);
        if (!state.card) {
            return;
        }
        if (!validate({
            cardSource: state.card,
            cardProvider: companyPropertiesData?.cardprovider || '',
            companyCards,
        })) {
            setPageLoading(false);
            return;
        }
        setCardName.mutate({
            cardSourceId: state.card.id || '',
            name: state.card.name || '',
            teamId: teamId?.[0] || '',
        }, {
            onSuccess: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: strings_1.inputStrings.SUBMIT_SUCCESS,
                    },
                ]);
            },
            onError: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.WARNING,
                        message: strings_1.inputStrings.SUBMIT_ERROR,
                    },
                ]);
            },
            onSettled: () => {
                initialize();
                toggleCardDetailsAside(false);
                setPageLoading(false);
            },
        });
    };
    const onSelectTeams = ({ id: newTeamIds }) => {
        const oldTeamIds = cardAsides.selectTeams.model.id;
        const teamsToBeAdded = (0, lodash_1.difference)(newTeamIds, oldTeamIds);
        const teamsToBeRemoved = (0, lodash_1.difference)(oldTeamIds, newTeamIds);
        try {
            teamsToBeAdded.map(teamId => addCardSourceToTeam.mutate({ teamId, cardSourceId: state.cardSourceDetail.cardSourceId }));
            teamsToBeRemoved.map(teamId => removeCardSourceFromTeam.mutate({ teamId, cardSourceId: state.cardSourceDetail.cardSourceId }));
            setCardAsides(prevState => ({
                ...prevState,
                selectTeams: {
                    ...prevState.selectTeams,
                    isOpen: false,
                    model: {
                        ...prevState.selectTeams.model,
                        id: newTeamIds,
                    },
                },
            }));
            state.setNotification([
                {
                    type: strings_1.notificationStrings.SUCCESS,
                    message: strings_1.cardDetailStrings.SELECT_TEAMS_SUBMIT_SUCCESS,
                },
            ]);
        }
        catch {
            state.setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? strings_1.errorStrings.DEFAULT
                        : strings_1.cardDetailStrings.SELECT_TEAMS_SUBMIT_ERROR,
                },
            ]);
        }
    };
    const onRemoveCard = () => {
        const cardSourceId = state.cardSourceDetail.cardSourceId;
        if (!cardSourceId) {
            logger.error({ message: 'cardSourceId is not defined' });
            return;
        }
        removeCardSourceFromTeam.mutate({ teamId: Array.isArray(teamId) && teamId.length > 0 ? teamId?.[0] : '', cardSourceId }, {
            onSuccess: () => {
                toggleCard(appConstants_1.cardDetailsAsideProperties.REMOVE_CARD, false);
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? strings_1.cardDetailStrings.HSBC_REMOVE_CARD_SUCCESS
                            : strings_1.cardDetailStrings.REMOVE_CARD_SUCCESS,
                    },
                ]);
            },
            onError: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.WARNING,
                        message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? strings_1.errorStrings.DEFAULT
                            : strings_1.cardDetailStrings.REMOVE_CARD_ERROR,
                    },
                ]);
            },
            onSettled: () => {
                state.setIsCardSourceDetailOpen({ isOpen: false, cardSourceId: '' });
                void Root_1.queryClient.invalidateQueries({
                    queryKey: [
                        paymentQuery_1.paymentKeys.getTeamCardSources({
                            includeTeamsCount: true,
                            teamId: teamId?.[0] || '',
                            isEnabled: true,
                        }),
                    ],
                });
                initialize();
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)(cards_1.default, { cardAsides: cardAsides, cardSource: state.card, toggleCard: toggleCard, onRemoveCard: onRemoveCard, setCardAsides: setCardAsides, onSelectTeams: onSelectTeams, saveConfirmAside: saveConfirmAside, includeRemoveCard: includeRemoveCard, includeSelectTeams: includeSelectTeams, submitCardSourceData: submitCardSourceData, linkCardSourceToTeam: linkCardSourceToTeam, toggleCardDetailsAside: toggleCardDetailsAside, cardOptions: cardAsides.selectTeams.options || [] })] }));
};
exports.default = TeamSettingsCardsPage;
